<template>
  <div id="app">
    <b-container class="selector">
    <h1>Choose your air purifier</h1>
    <h4>in just 2 steps</h4>

        <b-row>
            <b-col md>
                1. Select your room size:
                <v-select v-model="size" placeholder="Any" :options="sizeOptions"></v-select>
            </b-col>
            <b-col md>
                2. Choose what to filter:
                <v-select v-model="noise" placeholder="Any" :options="noiseOptions"></v-select>
            </b-col>
        </b-row>
    </b-container>
    <div id="message">
    </div>
    <div class="rr container">
    <transition name="fade" tag="div">
    <router-view :purifiers="purifiers" class="container"></router-view>
    </transition>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import router from '@/router/index.js'
import vSelect from 'vue-select'
import BootstrapVue from 'bootstrap-vue'
import VueAnalytics from 'vue-analytics'
import {diy, sqair, blast, blastmini, all, sqairCarbon} from '@/data/purifiers.js'
import * as Choice from '@/data/consts.js'

Vue.use(VueAnalytics, {
  id: 'UA-44139921-1',
  router,
  autoTracking: {
    pageviewTemplate (route) {
      return {
        page: 'purifier-comparison' + route.path,
        title: document.title,
        location: window.location.href
      }
    }
  }
})

Vue.component('v-select', vSelect)
Vue.use(BootstrapVue)
export default {
  name: 'App',
  title () {
    return this.title
  },
  data: () => ({
    purifiers: all,
    validPurifiers: all,
    choices: [],
    size: null,
    noise: null,
    price: null,
    sizeOptions: [
      {label: 'Small (<15m²)', purifiers: [diy, sqair, sqairCarbon], type: Choice.size, flag: 0, id: 'small-room'},
      {label: 'Medium (15-40m²)', purifiers: [sqair, sqairCarbon, blastmini], type: Choice.size, flag: 0, id: 'living-room'},
      {label: 'Large (40-100m²)', purifiers: [blastmini, blast], type: Choice.size, flag: 1, id: 'apartment'},
      {label: 'Larger or office (>100m²)', purifiers: [blast], type: Choice.size, flag: 1, id: 'large-apartment'}
    ],
    noiseOptions: [
      {label: 'Particulate such as PM2.5, dust and pollen', purifiers: all, type: Choice.noise, flag: 0, id: 'little-noise'},
      {label: 'Both particulate and gases (VOCs)', purifiers: [sqairCarbon, blastmini, blast], type: Choice.noise, flag: 1, id: 'sentivie-to-noise'}
    ],
    priceOptions: [
      {label: 'Dirt Cheap! (<230RMB)', purifiers: [diy], type: Choice.price, flag: 0, id: 'cheap'},
      {label: 'Mid range (<600RMB)', purifiers: [diy, sqair], type: Choice.price, flag: 0, id: 'mid-range'},
      {label: 'Bigger beasts (>1000RMB)', purifiers: [blastmini, blast], type: Choice.price, flag: 1, id: 'bigger-beasts'}
    ]
  }),
  computed: {
    isDetailPage: function () {
      return this.$route.name !== 'SelectorView'
    },
    selection: function () {
      return [this.size, this.noise, this.price]
    },
    message: function () {
      if (this.isDetailPage) {
        return 'Here\'s the lowdown on the purifier you selected'
      }
      if (!this.choices.length) {
        return 'Here\'s a list of all Smart Air Purifiers to get you started'
      }
      if (this.validPurifiers.length) {
        var multiple = this.validPurifiers.length > 1
        return 'Good news! ' + (multiple ? 'These' : 'This') + ' purifier' + (multiple ? 's' : '') + ' meet' + (multiple ? '' : 's') + ' your criteria! Select a purifier to learn more.'
      } else {
        return 'None of the Smart Air Purifiers meet all your criteria :\'('
      }
    },
    title: function () {
      return 'aaa'
    }
  },
  methods: {
    intersect: function (a, b) {
      var t
      if (b.length > a.length) {
        t = b
        b = a
        a = t
      } // indexOf to loop over shorter
      return a.filter(function (e) {
        return b.indexOf(e) > -1
      }).filter(function (e, i, c) { // extra step to remove duplicates
        return c.indexOf(e) === i
      })
    }
  },
  watch: {
    selection: function () {
      if (this.isDetailPage) {
        this.$router.push('/')
      }
      var vue = this
      // get list of all valid purifiers:
      this.choices = this.selection.filter(function (i) { return (i !== null) })
      if (!this.choices.length) {
        this.validPurifiers = null
        this.purifiers = all
        return
      }
      this.choices.forEach(function (choice) {
        vue.$ga.event({
          eventCategory: 'PurifierSelector',
          eventAction: 'changed',
          eventLabel: choice.type,
          eventValue: choice.id
        })
      })
      var validPurifiers = this.choices[0].purifiers
      this.choices.slice(1).forEach(
        function (choice) {
          validPurifiers = vue.intersect(validPurifiers, choice.purifiers)
        })
      this.validPurifiers = validPurifiers
      if (validPurifiers.length) {
        this.purifiers = validPurifiers
        return
      }
      if (this.noise && this.noise.flag === 1) {
        // user is sensitive to noise
        this.$router.push('/sensitive-to-noise')
        return
      }
      if (this.price && this.price.flag === 0) {
        this.$router.push('/low-cost-purifiers')
        return
      }
      this.$router.push('/no-purifier-selection')
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #355197;
  margin: 10px 0;
  background-color:#fdfdfd;
}
#message {
  margin: 40px 0;
  font-style:italic;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
#instructions {
  margin: 40px auto;
  width:80%;
}
.router {
  border:1px solid #ccc;
  border-radius:3px;
  padding:30px;
}
.tooltip-inner {
  background-color:#444;
  opacity:1;
}

a {
  color:#355197;
}
</style>



// WEBPACK FOOTER //
// src/App.vue